import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ChatList from "src/Components/Custom/ChatList/ChatList";
import ContactsModal from "src/Components/Custom/ContactsModal/ContactsModal";
import Messages from "src/Components/Custom/Messages/Messages";
import { useTranslation } from "react-i18next";

function Chat() {
  const { t, i18n } = useTranslation();
  const params: any = useParams();
  const { id: chatId } = params;
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);
  const [chatData, setChatData] = useState<any>();
  return (
    <>
      <div id="content" className={`${i18n.dir() === 'rtl'?'rtl-content-padding':'ltr-content-padding'}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className="col_selector">
                {chatId ? (
                  <div className="chat">
                    <Messages
                      placeholderMessage={"No Messages"}
                      chatData={chatData}
                    />
                  </div>
                ) : (
                    <div className="messages pt-4 post_feed">
                      <ChatList
                        setModalVisibility={setModalVisibility}
                        setChatData={setChatData}
                        placeholderMessage={"No Chats"}
                      />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalVisibility ? (
        <ContactsModal
          showModal={modalVisibility}
          setModalVisibility={setModalVisibility}
          setChatData={setChatData}
        />
      ) : (
          <></>
        )}
    </>
  );
}

export default Chat;
